var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteKubRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 149,
    viewBox: "0 0 85 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.328 -21.1337L63.4883 -21.1337L63.4883 0.132812L42.328 0.132813L42.328 -21.1337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1639 106.467L42.3242 106.467L42.3242 127.733L21.1639 127.733L21.1639 106.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3397 63.5733L42.5 63.5733L42.5 84.8398L21.3397 84.8398L21.3397 63.5733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1639 -21.1337L42.3242 -21.1337L42.3242 0.132812L21.1639 0.132813L21.1639 -21.1337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00374946 63.9327L21.1641 63.9327L21.1641 85.1992L0.00374972 85.1992L0.00374946 63.9327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000156787 21.4005L21.1602 21.4005L21.1602 42.667L-0.000156533 42.667L-0.000156787 21.4005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.328 21.4005L63.4883 21.4005L63.4883 42.667L42.328 42.667L42.328 21.4005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00374946 127.733L21.1641 127.733L21.1641 149L0.00374972 149L0.00374946 127.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8397 127.147L85 127.147L85 148.413L63.8397 148.413L63.8397 127.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0936 84.4337L63.2539 84.4337L63.2539 105.7L42.0936 105.7L42.0936 84.4337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8162 63.5733L86.9766 63.5733L86.9766 84.8398L65.8162 84.8398L65.8162 63.5733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6952 127.733L105.855 127.733L105.855 149L84.6952 149L84.6952 127.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000156787 0.132883L21.1602 0.132883L21.1602 21.3994L-0.000156533 21.3994L-0.000156787 0.132883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1639 0.13386L42.3242 0.13386L42.3242 21.4004L21.1639 21.4004L21.1639 0.13386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8397 7.08242e-05L85 7.05719e-05L85 21.2666L63.8397 21.2666L63.8397 7.08242e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000156787 85.2003L21.1602 85.2003L21.1602 106.467L-0.000156533 106.467L-0.000156787 85.2003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 85,
    fill: "white",
    transform: "matrix(-1.19249e-08 -1 -1 1.19249e-08 85 149)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteKubRight);
export default __webpack_public_path__ + "static/media/white-kub-right.df8113df54702187914e179495446073.svg";
export { ForwardRef as ReactComponent };